<template>
<!-- final Conditions -->
<form id="conditions-form">
<div class="text-color-text font-semibold text-3xl rounded-lg flex flex-col items-center mt-4">
	<!-- contract number -->
	<div class="w-full grid grid-flow-col items-justify-center grid-cols-5 gap-4 mt-2" v-if="enyAdmin">
		<div class='px-4'>{{ $t('eny.contract_number') }}</div>
		<div class="items-center mx-4 col-start-3 col-span-3">
			<validation>
				<ejs-maskedtextbox id="contract_number" name="contract_number" floatLabelType="Auto" :readonly="readOnly" v-model:value="conditions_loc.contract_number"></ejs-maskedtextbox>
			</validation>
		</div>
	</div>
	<!-- amount -->
	<div class="w-full grid grid-flow-col items-justify-center grid-cols-5 gap-4 mt-2">
		<div class='px-4'>{{ $t('eny.amount') }}</div>
		<div class="items-center mx-4 col-start-3 col-span-3">
			<validation>
				<div class="flex flex-row">
					<ejs-maskedtextbox id="amount" name="amount" floatLabelType="Auto" :readonly="readOnly" v-model:value="conditions_loc.amount"></ejs-maskedtextbox>
					<text-box-extension :label="$t('eny.chf')" cssClass="!mt-0" />
				</div>
			</validation>
		</div>
	</div>
	<!-- duration -->
	<div class="w-full grid grid-flow-col items-justify-center grid-cols-5 gap-4 mt-2">
		<div class='px-4'>{{ $t('eny.duration') }}</div>
		<div class="items-center mx-4 col-start-3 col-span-3">
			<validation><ejs-maskedtextbox id="duration" name="duration" floatLabelType="Auto" :readonly="readOnly" v-model:value="conditions_loc.duration"></ejs-maskedtextbox></validation>
		</div>
	</div>
	<!-- bank -->
	<div class="w-full grid grid-flow-col items-justify-center grid-cols-5 gap-4 mt-2">
		<div class='px-4'>{{ $t('eny.bank') }}</div>
		<div class="items-center mx-4 col-start-3 col-span-3">
			<validation>
				<ejs-dropdown id='bank' name='bank' :dataSource='banks' :fields='fields' floatLabelType="Auto" :showClearButton="false" :allowCustom="false" v-model:value="conditions_loc.bank" :readonly="readOnly"></ejs-dropdown>
			</validation>
		</div>
	</div>
	<!-- interest rate -->
	<div class="w-full grid grid-flow-col items-justify-center grid-cols-5 gap-4 mt-2">
		<div class='px-4'>{{ $t('eny.interestrate') }}</div>
		<div class="items-center mx-4 col-start-3 col-span-3">
			<validation>
				<ejs-maskedtextbox id="interestrate" name="interestrate" floatLabelType="Auto" :readonly="readOnly" v-model:value="conditions_loc.interest_rate"></ejs-maskedtextbox>
				<text-box-extension label="%" cssClass="!mt-0" />
			</validation>
		</div>
	</div>
	<!-- max amount -->
	<div class="w-full grid grid-flow-col items-justify-center grid-cols-5 gap-4 mt-2" v-if="enyAdmin">
		<div class='px-4'>{{ $t('eny.max_amount') }}</div>
		<div class="items-center mx-4 col-start-3 col-span-3">
			<validation>
				<ejs-maskedtextbox id="max_amount" name="max_amount" floatLabelType="Auto" :readonly="readOnly" v-model:value="conditions_loc.max_amount"></ejs-maskedtextbox>
				<text-box-extension :label="$t('eny.chf')" cssClass="!mt-0" />
			</validation>
		</div>
	</div>
	<!-- first installment -->
	<div :visible='enyAdmin' class="w-full grid grid-flow-col items-justify-center grid-cols-5 gap-4 mt-3" v-if="enyAdmin">
		<div class='px-4'>{{ $t('eny.first_installment') }}</div>
		<div class="items-center mx-4 col-start-3 col-span-3">
			<validation>
				<ejs-datepicker name='first_installment' floatLabelType="Auto" placeholder="" :format="$t('eny.date_format')" :open='onOpen' v-model:value="conditions_loc.first_installment"></ejs-datepicker>
			</validation>
		</div>
	</div>
	<!-- payout date -->
	<div :visible='enyAdmin' class="w-full grid grid-flow-col items-justify-center grid-cols-5 gap-4 mt-3" v-if="enyAdmin">
		<div class='px-4'>{{ $t('eny.payout_date') }}</div>
		<div class="items-center mx-4 col-start-3 col-span-3">
			<validation>
				<ejs-datepicker name='payout_date' floatLabelType="Auto" placeholder="" :format="$t('eny.date_format')" :open='onOpen' v-model:value="conditions_loc.payout_date"></ejs-datepicker>
			</validation>
		</div>
	</div>
	<!-- commission -->
	<div class="w-full grid grid-flow-col items-justify-center grid-cols-5 gap-4 mt-2" v-if="enyAdmin">
		<div class='px-4'>{{ $t('eny.commission') }}</div>
		<div class="items-center mx-4 col-start-3 col-span-3">
			<validation>
				<ejs-maskedtextbox id="commission" name="commission" floatLabelType="Auto" :readonly="readOnly" v-model:value="conditions_loc.commission"></ejs-maskedtextbox>
				<text-box-extension :label="$t('eny.chf')" cssClass="!mt-0" />
			</validation>
		</div>
	</div>
	<!-- ppi -->
	<div class="w-full grid grid-flow-col items-justify-center grid-cols-5 gap-4 mt-3" v-if="enyAdmin">
		<div class='px-4'>{{ $t('eny.ppi') }}</div>
		<div class="items-center mx-4 col-start-3 col-span-3">
			<validation>
				<div class='eny-radio-toolbar w-full text-base'>
					<div class="eny-radio">
						<input type="radio" id="radio_ppi_1" name="ppi" value='1' v-model="conditions_loc.ppi" />
						<label for="radio_ppi_1"><span>{{$t('eny.yes')}}</span></label>
					</div>
					<div class="eny-radio">
						<input type="radio" id="radio_ppi_0" name="ppi" value='0' v-model="conditions_loc.ppi" />
						<label for="radio_ppi_0"><span>{{$t('eny.no')}}</span></label>
					</div>
				</div>
			</validation>
		</div>
	</div>
	<!-- save button -->
	<div class="w-full md:px-20 pt-5 flex flex-row justify-center gap-2">
		<button v-if="!readOnly" class="eny-btn-blue px-8 py-2 text-2xl font-bold" type="button" @click="onSave">{{$t('eny.save')}}</button>
		<button v-if="enyAdmin" class="eny-btn-blue px-8 py-2 text-2xl font-bold" type="button" @click="downloadBankdataXML">{{$t('eny.export_bank_now')}}</button>
		<button v-if="enyAdmin" class="eny-btn-blue px-8 py-2 text-2xl font-bold" type="button" @click="downloadCembraXML">{{$t('eny.export_cembra')}}</button>
	</div>
</div>
</form>
</template>

<script>
import { MaskedTextBoxComponent, FormValidator } from '@syncfusion/ej2-vue-inputs';
import { DatePickerComponent } from "@syncfusion/ej2-vue-calendars";
import { DropDownListComponent } from "@syncfusion/ej2-vue-dropdowns";
import TextBoxExtension from "../../Helper/TextBoxExtension.vue";
import Validation from "../../Base/Validation.vue";
import { mapGetters } from 'vuex';
import axios from "axios";
import useUtils from '../../hooks/useUtils';

export default {
	name: "DashboardFinalConditions",
	props: ['readOnly'],
	components: {
		'ejs-maskedtextbox': MaskedTextBoxComponent,
		"ejs-datepicker": DatePickerComponent,
		"ejs-dropdown": DropDownListComponent,
		'text-box-extension': TextBoxExtension,
		'validation': Validation,
	},
	setup(){
		const { sleep, sendToBrowser, sortList, timeZoneOffsetOnInit, timeZoneOffsetOnSave, isFormattedDateValid } = useUtils();
		return {
			sleep,
			sendToBrowser,
			sortList,
			timeZoneOffsetOnInit,
			timeZoneOffsetOnSave,
			isFormattedDateValid
		}
	},
	data() {
		return {
			banks: this.sortList(JSON.parse(this.$t('eny.banks_final_conditions')), 'value', 'label', 'ot'),
			fields : { text: 'label', value: 'value' },
		};
	},
	created() {
		this.$store.dispatch('customer/loadFinalConditions', this.$route.params.uid)
	},
	mounted() {
		let options = {
			rules: {
				contract_number: { regex: ['^[0-9]+$', this.$t('eny.number_notempty_error_msg')], max:9999999999},
				amount: { number: [true, this.$t('eny.number_notempty_error_msg')], max:999999.99},
				max_amount: { number: [true, this.$t('eny.number_notempty_error_msg')], max:999999.99},
				duration: { regex: ['^[0-9]+$', this.$t('eny.number_notempty_error_msg')], max:9999999999 },
				interestrate: { regex: ['^\\d+(\\.\\d+)?$', this.$t('eny.number_notempty_positive_error_msg')], max:999999.99 },
			},
			customPlacement: this.showValidationError,
		};
		if (this.enyAdmin){
			const additionalValidation = {
				contract_number: {regex: ['^[0-9]+$', this.$t('eny.number_notempty_error_msg')], max: 9999999999},
				max_amount: {number: [true, this.$t('eny.number_notempty_error_msg')], max: 999999.99},
				commission: {number: [true, this.$t('eny.number_notempty_error_msg')], max: 999999.99},
				first_installment: {custom: [this.isValidDate, this.$t('eny.date_not_valid_msg')]},
				payout_date: {custom: [this.isValidDate, this.$t('eny.date_not_valid_msg')]}
			};
			options.rules = {...options.rules, ...additionalValidation};
		}
		this.formObject = new FormValidator("#conditions-form", options);
	},
	computed: {
		...mapGetters('customer', ['request', 'final_conditions']),
		conditions_loc() {
			return this.final_conditions;
		},
		enyAdmin: function() {
			return this.$keycloak.hasRealmRole('admin');
		}
	},
	watch: {
		'final_conditions': function(newVal) {
			this.final_conditions.first_installment = this.timeZoneOffsetOnInit(newVal.first_installment)
			this.final_conditions.payout_date = this.timeZoneOffsetOnInit(newVal.payout_date)
		}
	},
	methods: {
		onOpen: function(e) {
			this.sleep(10).then(function() {
				e.popup.offsetX = e.popup.relateTo.clientWidth - e.popup.properties.content.clientWidth;
			});
		},
		onSave() {
			if (this.formObject.validate() && this.request.id) {
				let data = this.conditions_loc;
				data.requestId = this.request.id;
				data.first_installment = this.timeZoneOffsetOnSave(data.first_installment);
				data.payout_date = this.timeZoneOffsetOnSave(data.payout_date);
				this.$store.dispatch('customer/saveFinalConditions', data);
			}
		},
		downloadBankdataXML() {
			axios.get('/customer/get_bankdata/' + this.request.id, { responseType: 'blob' }).then((response) => {
				const fileName = 'bankdata.xml';
				this.sendToBrowser(response.data, fileName);
			}).catch(async (error) => {
				const response = error.response;
				if (typeof response.data.text === 'function') {
					alert(await response.data.text());
				} else {
					alert(response.data);
				}
			});
		},
		downloadCembraXML() {
			axios.get('/customer/get_cembra/' + this.request.id, { responseType: 'blob' }).then((responce) => {
				const fileName = 'cembradata.xml';
				this.sendToBrowser(responce.data, fileName);
			}).catch(async (error) => {
				const response = error.response
				if (typeof response.data.text === 'function' ) {
						alert(await response.data.text());
				} else {
					alert(response.data)
				}
			});
		},
		showValidationError: function(element, errorElement) {
			element.closest('.validation-group').querySelector('.error-element').appendChild(errorElement);
		},
		isValidDate(input) {
			return this.isFormattedDateValid(input.value, this.$t('eny.moment_date_format'));
		}
	},
}
</script>
<style>
.e-float-input, .e-float-input.e-control-wrapper{
	margin-top: 1px;
}
</style>
